import CONSTANTS from '../CONSTANTS';

const initialState = {
  kits: {},
  patientKits: {},
  types: {},
  kitEdit: {},
  kitsCount: {}
};

const kitsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.KITS_SET_LIST:
      return { ...state, kits: action.kits };
    case CONSTANTS.KITS_SET_EDIT:
      return { ...state, kitEdit: action.kit };
    case CONSTANTS.KITS_PATIENTS_SET: 
      return { ...state, patientKits: action.kits };

    case CONSTANTS.KITS_UPDATE_IN_LIST: {
      //get list of kits IDs only
      let kitsIDList = state.kits.data.map(a => a._id);
      let newKitList = [...state.kits.data];
      const kitIndex = kitsIDList.indexOf(action.kitId);

      if (kitIndex > -1) {
        newKitList[kitIndex] = action.data;
      }

      return {...state, kits: {...state.kits, data: [...newKitList]}};
    }

    case CONSTANTS.KITS_SET_COUNT_BY_TYPE:
      return { ...state, kitsCount: action.count };

    case CONSTANTS.KITS_SET_TYPES: 
      return { ...state, types: action.types };

    default:
      return state;
  }
};

export default kitsReducer;